import { ReactEditor } from 'slate-react';

import { withNormalizeElementPlugin } from '../../handlers/normalize-element/withNormalizeElement';
import { ELEMENT_NUMBERING } from './defaults';

export const withNumberingPlugin =
  (options?) =>
  <T extends ReactEditor>(editor: T) => {
    return withNormalizeElementPlugin({ type: ELEMENT_NUMBERING })(editor);
  };
